export const GET_DYNAMIC_VARIABLES = 'GET_DYNAMIC_VARIABLES'
export const GET_DYNAMIC_VARIABLE_VALUES = 'GET_DYNAMIC_VARIABLE_VALUES'
export const CREATE_DYNAMIC_VARIABLE = 'CREATE_DYNAMIC_VARIABLE'
export const UPDATE_DYNAMIC_VARIABLE_TITLE = 'UPDATE_DYNAMIC_VARIABLE_TITLE'
export const DELETE_DYNAMIC_VARIABLE = 'DELETE_DYNAMIC_VARIABLE'
export const CREATE_DYNAMIC_VARIABLE_VALUE = 'CREATE_DYNAMIC_VARIABLE_VALUE'
export const DELETE_DYNAMIC_VARIABLE_VALUE = 'DELETE_DYNAMIC_VARIABLE_VALUE'
